import React from 'react';

export default function BlueEnvelopeConsideration() {
  return (
    <div className="max-w-4xl mx-auto bg-white p-8">
      <p className="font-bold text-base mb-4">
        Blue Envelope – Context and Considerations
      </p>

      <p className="mb-2">What the Blue Envelope May Indicate</p>

      <p className="mb-2">
        The presence of a Blue Envelope may indicate that the driver could benefit from additional time and clear communication during the interaction.
      </p>

      <p className="mb-2">You may observe:</p>

      <p className="mb-1">Delayed or limited verbal responses</p>

      <p className="mb-1">Repetitive movements or fidgeting</p>

      <p className="mb-1">Limited or atypical eye contact</p>

      <p className="mb-1">Heightened response to lights, sounds, or sudden movements</p>

      <p className="mb-6">
        These behaviors are often stress-related and are not intentional.
      </p>

      <p className="mb-2">Information Included in the Blue Envelope</p>

      <p className="mb-2">
        The Blue Envelope may contain documents and information intended to support communication during the interaction.
      </p>

      <p className="mb-2">This may include:</p>

      <p className="mb-1">Vehicle-related documents (such as registration or insurance)</p>

      <p className="mb-1">A driver information form</p>

      <p className="mb-1">Emergency contact information provided voluntarily by the driver</p>

      <p className="mb-6">
        Emergency contact details, if present, are intended to support communication and safety if additional assistance is needed.
      </p>

      <p className="mb-2">Communication Considerations</p>

      <p className="mb-2">
        In many situations, clear and simple communication can support understanding.
      </p>

      <p className="mb-4">
        Allowing additional time for responses and minimizing unnecessary sensory input may help reduce stress and confusion.
      </p>

      <p className="mb-2">Important Notes</p>

      <p className="mb-1">The Blue Envelope does not replace standard procedures.</p>

      <p className="mb-1">It does not indicate a specific diagnosis.</p>

      <p className="mb-1">It does not limit discretion or authority.</p>

      <p className="mb-1">Participation in the program is voluntary.</p>

      <p className="mb-4">Additional information is provided within the Blue Envelope materials.</p>
    </div>
  );
}